
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 10 10.002"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_44909","data-name":"Group 44909","transform":"translate(-115 -344.999)"}},[_c('rect',{attrs:{"id":"Rectangle_15042","data-name":"Rectangle 15042","width":"10","height":"10","transform":"translate(115 345)","fill":"none"}}),_c('path',{attrs:{"id":"Path_30603","data-name":"Path 30603","d":"M8.008 1.876A2.71 2.71 0 005.3 4.586v1.089a1.549 1.549 0 00-1.55 1.549v3.105a1.549 1.549 0 001.55 1.549h5.42a1.549 1.549 0 001.549-1.549V7.224a1.549 1.549 0 00-1.549-1.549V4.586a2.71 2.71 0 00-2.712-2.71zm1.936 3.8v-1.09a1.936 1.936 0 10-3.871 0v1.089z","transform":"translate(111.992 343.123)","fill":"#727998","fill-rule":"evenodd"}})])])
          )
        }
      }
    